export default __webpack_public_path__ + "static/rouge_gourmand-c2e72785d2dbc12107db33fc513d4f75.png";